import Vue from 'vue'
import store from '../store'

Vue.directive('specialrole', {
  bind (el) {
    console.log('el:' , el, store.state.specialRole)
    if (store.state.specialRole) {
      el.style.display = 'none'
    }
  }
})